import { AppRoutes } from "../../types/enums/appRoutes";

function withFilter(route: string, id: string, tab?: string) {
  const params = new URLSearchParams({ filterId: id });
  if (tab != null) {
    params.set("tab", tab);
  }
  return `${route}?${params.toString()}`;
}

function withFocus(route: string, id: string, tab?: string) {
  const params = new URLSearchParams({ focusId: id });
  if (tab != null) {
    params.set("tab", tab);
  }
  return `${route}?${params.toString()}`;
}

export function getInsightEvidenceRoute(id: string, sourceType?: string | null) {
  const reference = id.trim();
  const type = sourceType?.toLocaleLowerCase() ?? "";

  if (type.includes("decision")) {
    return withFilter(AppRoutes.decisionsLog, reference);
  }
  if (type.includes("dependency")) {
    return withFilter(AppRoutes.raid, reference, "dependencies");
  }
  if (type.includes("risk") || type.includes("issue")) {
    return withFilter(AppRoutes.raid, reference, "risks-issues");
  }
  if (type.includes("assumption")) {
    return withFilter(AppRoutes.raid, reference, "assumptions");
  }
  if (type.includes("checklist") || type.includes("requirement")) {
    return withFilter(AppRoutes.checklist, reference);
  }
  if (type.includes("planning") || type.includes("milestone") || type.includes("activity")) {
    return withFocus(AppRoutes.integrationPlanning, reference, "detailed-view");
  }

  if (/^(?:DEC|DECISION)-[A-Z0-9-]+$/i.test(reference)) {
    return withFilter(AppRoutes.decisionsLog, reference);
  }
  if (/^(?:DEP|DEPENDENCY)-[A-Z0-9-]+$/i.test(reference)) {
    return withFilter(AppRoutes.raid, reference, "dependencies");
  }
  if (/^(?:R|I|RISK|ISSUE|RAID-[RI])-[A-Z0-9-]+$/i.test(reference)) {
    return withFilter(AppRoutes.raid, reference, "risks-issues");
  }
  if (/^(?:A|ASM|ASSUMPTION|RAID-A)-[A-Z0-9-]+$/i.test(reference)) {
    return withFilter(AppRoutes.raid, reference, "assumptions");
  }
  if (/^(?:HR|CHK|CHECKLIST|REQ|REQUIREMENT)-[A-Z0-9-]+$/i.test(reference)) {
    return withFilter(AppRoutes.checklist, reference);
  }
  if (/^(?:PLAN|PLANNING)-[A-Z0-9-]+$/i.test(reference) || /^L\d+-[A-Z0-9-]+$/i.test(reference)) {
    return withFocus(AppRoutes.integrationPlanning, reference, "detailed-view");
  }

  return undefined;
}

export function getInsightEvidenceRouteForLookup(
  id: string,
  sourceType: string | null | undefined,
  raidType: string | null | undefined,
  isPlanningItem: boolean,
  isChecklistItem = false
) {
  const typedRoute = getInsightEvidenceRoute(id, sourceType);
  if (typedRoute != null) {
    return typedRoute;
  }

  if (isChecklistItem) {
    return withFilter(AppRoutes.checklist, id);
  }

  const normalizedRaidType = raidType?.trim().toLocaleLowerCase();
  if (normalizedRaidType?.includes("decision")) {
    return withFilter(AppRoutes.decisionsLog, id);
  }
  if (normalizedRaidType?.includes("dependency")) {
    return withFilter(AppRoutes.raid, id, "dependencies");
  }
  if (normalizedRaidType?.includes("assumption")) {
    return withFilter(AppRoutes.raid, id, "assumptions");
  }
  if (normalizedRaidType?.includes("risk") || normalizedRaidType?.includes("issue")) {
    return withFilter(AppRoutes.raid, id, "risks-issues");
  }

  return isPlanningItem
    ? withFocus(AppRoutes.integrationPlanning, id, "detailed-view")
    : undefined;
}
